/**
 * Fires `browser:back` when the customer uses the browser back button.
 *
 * @example
 * document.addEventListener('browser:back', (event) => {
 *   console.log(event.detail.source, event.detail.url);
 * });
 */
(function browserBackEvent() {
  const EVENT_NAME = 'browser:back';

  /**
   * @param {'popstate' | 'back_forward' | 'bfcache'} source
   */
  function fire(source) {
    document.dispatchEvent(
      new CustomEvent(EVENT_NAME, {
        bubbles: true,
        cancelable: true,
        detail: {
          source,
          url: location.href,
          referrer: document.referrer,
        },
      })
    );
  }

  window.addEventListener('popstate', function () {
    fire('popstate');
  });

  window.addEventListener('pageshow', function (event) {
    if (event.persisted) fire('bfcache');
  });

  const nav = performance.getEntriesByType('navigation')[0];
  if (nav instanceof PerformanceNavigationTiming && nav.type === 'back_forward') {
    fire('back_forward');
  }
})();
